<template>
  <div class="consultation-book-page">
    <div class="mobile-header">
      <!-- 搜索框 -->
      <div class="search-box">
        <input type="text" v-model="concatName" @input="onSearch" placeholder="搜索线索姓名/手机号" class="search-input" />
        <div class="add-clue" @click="addClue">
          <span class="icon">+</span>
        </div>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-bar">
        <div class="filter-item" @click="toggleAllFilter">
          <span>{{ allFilterText }}</span>
          <span class="arrow">▼</span>
        </div>
        <div class="filter-item" @click="toggleQuickFilter">
          <span>{{ quickFilterText }}</span>
          <span class="arrow">▼</span>
        </div>
      </div>

      <!-- 全部筛选下拉框 -->
      <div v-if="showAllFilter" class="filter-dropdown">
        <div class="dropdown-item" :class="{ active: allFilter === 'all' }" @click="selectAllFilter('all')">全部</div>
        <div class="dropdown-item" :class="{ active: allFilter === 'hasFollow' }" @click="selectAllFilter('hasFollow')">
          有跟进人
        </div>
        <div class="dropdown-item" :class="{ active: allFilter === 'noFollow' }" @click="selectAllFilter('noFollow')">
          无跟进人
        </div>
        <div class="dropdown-item" :class="{ active: allFilter === 'myClue' }" @click="selectAllFilter('myClue')">
          我的线索
        </div>
        <div class="dropdown-item" :class="{ active: allFilter === 'beImproveContact' }" @click="selectAllFilter('beImproveContact')">
          待完善联系方式
        </div>
      </div>

      <!-- 快捷筛选下拉框 -->
      <div v-if="showQuickFilter" class="filter-dropdown">
        <div class="dropdown-item" :class="{ active: quickFilter === '' }" @click="selectQuickFilter('')">
          全部
        </div>
        <div class="dropdown-item" :class="{ active: quickFilter === 'todayFollow' }"
          @click="selectQuickFilter('todayFollow')">
          今日待跟进({{ statisticsData?.todayFollowCount || 0 }})
        </div>
        <div class="dropdown-item" :class="{ active: quickFilter === 'sevenDaysNoFollow' }"
          @click="selectQuickFilter('sevenDaysNoFollow')">
          7天未跟进({{ statisticsData?.notFollowed7d || 0 }})
        </div>
        <div class="dropdown-item" :class="{ active: quickFilter === 'thirtyDaysNoConvert' }"
          @click="selectQuickFilter('thirtyDaysNoConvert')">
          30天未转化({{ statisticsData?.notBill30d || 0 }})
        </div>
        <div class="dropdown-item" :class="{ active: quickFilter === 'todayNew' }"
          @click="selectQuickFilter('todayNew')">
          今日新增({{ statisticsData?.todayCount || 0 }})
        </div>
        <div class="dropdown-item" :class="{ active: quickFilter === 'thisWeekNew' }"
          @click="selectQuickFilter('thisWeekNew')">
          本周新增({{ statisticsData?.weekCount || 0 }})
        </div>
        <div class="dropdown-item" :class="{ active: quickFilter === 'thisMonthNew' }"
          @click="selectQuickFilter('thisMonthNew')">
          本月新增({{ statisticsData?.monthCount || 0 }})
        </div>
      </div>
    </div>

    <!-- 页面内容 -->
    <div class="page-content" ref="pageContent" @scroll="handleScroll">
      <!-- 线索列表 -->
      <div class="lead-item" v-for="item in consulationBookList" :key="item.consultationBookId" @click="goRecord(item)">
        <!-- 线索头部 -->
        <div class="lead-header">
          <div class="name-section">
            <span class="name">{{ item.contactName }}</span>
            <span class="grade-tag">{{ selectDictLabel(gradeList, item.grade) }}</span>
          </div>
          <div class="action-row">
            <span v-if="item.phone" class="phone-icon" @click.stop="makeCall(item.phone)">📞</span>
            <span class="status-tag" :class="getStatusClass(item)">{{ selectDictLabel(statusList, item.status) || '待跟进'
              }}</span>
          </div>
        </div>

        <!-- 线索详情 -->
        <div class="lead-detail">
          <div class="detail-item">
            <span class="label">线索归类：</span>
            <span class="value">{{ selectDictLabel(typeList, item.type) || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">线索来源：</span>
            <span class="value">{{ selectDictLabel(sourceList, item.source) || '-' }}</span>
          </div>
          <div class="detail-item" v-if="item.activityName">
            <span class="label">活动名称：</span>
            <span class="value">{{ item.activityName || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">跟进人：</span>
            <span class="value">{{ item.followUserName || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">最后跟进时间：</span>
            <span class="value">{{ item.lastFollowUpTime || '-' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">创建时间：</span>
            <span class="value">{{ item.createTime }}</span>
          </div>
        </div>

        <!-- 操作按钮 -->
        <div class="lead-actions">
          <van-button plain
            v-if="(item.status === 0 || item.status === 1 || item.status === 2) && hasPermission('enrollment:consultationBook:edit')"
            type="primary" size="normal" @click.stop="handleUpdate(item)" class="action-btn">修改</van-button>
          <van-button plain v-if="item.followUserId" type="primary" size="normal"
            @click.stop="followRecord(item.consultationBookId)" class="action-btn">跟进</van-button>
          <van-button plain v-if="!item.followUserId" type="warning" size="normal"
            @click.stop="claimLead(item.consultationBookId)" class="action-btn">认领</van-button>
          <van-button plain type="danger" size="normal" @click.stop="openPicker(item)"
            v-if="hasPermission('enrollment:consultationBook:changeFollowUser')" class="action-btn">分配</van-button>
        </div>
      </div>

      <!-- 加载状态 -->
      <div v-if="loading" class="loading">正在加载...</div>
      <div v-if="!hasMore && !loading" class="no-more">没有更多数据了</div>

      <!-- 分配跟进人弹窗 -->
      <van-popup v-model:show="showPicker" position="bottom" round safe-area-inset-bottom
        :style="{ bottom: 'calc(56px + env(safe-area-inset-bottom))' }">
        <div>
          <van-search v-model="followerSearchQuery" placeholder="搜索跟进人姓名" show-action
            @update:model-value="filterFollowers" @cancel="showPicker = false" background="#f7f8fa" />
          <div style="height: 40vh; overflow-y: auto;">
            <van-cell v-for="follower in filteredFollowerList" :key="follower.userId" :title="follower.nickName"
              @click="selectFollower(follower)" :border="true"
              :class="{ 'selected-cell': selectedFollower && selectedFollower.userId === follower.userId }"
              :value="selectedFollower && selectedFollower.userId === follower.userId ? '✓' : ''" />
          </div>
          <div style="display: flex; border-top: 1px solid #f0f0f0;">
            <van-button type="default" block @click="cancelAssign" style="margin: 10px;">取消</van-button>
            <van-button type="primary" block @click="confirmAssign" style="margin: 10px;">
              确定
            </van-button>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
export default { name: 'ConsultationBook' }
</script>
<script setup>
import { onActivated, onMounted, onUnmounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { getConsulationBookList, changeFollowUser, getStatistics, claim } from '@/api/consultationBook'
import { getUserInfo as getLocalUserInfo, setUserInfo } from '@/utils/authUtils'
import { showSuccessToast, showFailToast, showConfirmDialog } from 'vant'
import { getUserInfo } from '@/api/auth'
import { getUserListByMenuPerms } from '@/api/user'
import { ensureWecomLogin } from '@/utils/wecomAuth'
import { useDict } from '@/utils/dict'
import { selectDictLabel } from '@/utils/dict'

let scrollPosition = 0
window.consultationBookNeedRefresh = false

// 筛选状态持久化 key
const FILTER_STORAGE_KEY = 'consultationBook_filter_state'

const router = useRouter()
const route = useRoute()
const pageContent = ref(null)
const { grade_list: gradeList, consultation_source: sourceList, consultation_status: statusList, marketing_activity_type: typeList } = useDict('grade_list', 'consultation_source', 'consultation_status', 'marketing_activity_type')

const consulationBookList = ref([])
const showPicker = ref(false)
const checkedItem = ref({})
const statisticsData = ref({})
const concatName = ref()
const searchTimer = ref(null)
const userInfo = ref(null)
const followerList = ref([])
const followerSearchQuery = ref('')
const filteredFollowerList = ref([])
const selectedFollower = ref(null)
const showAllFilter = ref(false)
const showQuickFilter = ref(false)
const allFilter = ref('all')
const quickFilter = ref('')
const allFilterText = ref('全部')
const quickFilterText = ref('快捷筛选')
const pageNum = ref(1)
const pageSize = ref(10)
const loading = ref(false)
const hasMore = ref(true)
const scrollTimeout = ref(null)
const dateRange = ref([])

// 保存筛选状态到 sessionStorage
function saveFilterState() {
  try {
    sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify({
      allFilter: allFilter.value,
      quickFilter: quickFilter.value,
      allFilterText: allFilterText.value,
      quickFilterText: quickFilterText.value,
      concatName: concatName.value
    }))
  } catch (e) { /* 忽略存储异常 */ }
}

// 从 sessionStorage 恢复筛选状态
function restoreFilterState() {
  try {
    const saved = sessionStorage.getItem(FILTER_STORAGE_KEY)
    if (!saved) return
    const state = JSON.parse(saved)
    if (state.allFilter !== undefined) allFilter.value = state.allFilter
    if (state.quickFilter !== undefined) quickFilter.value = state.quickFilter
    if (state.allFilterText !== undefined) allFilterText.value = state.allFilterText
    if (state.quickFilterText !== undefined) quickFilterText.value = state.quickFilterText
    if (state.concatName !== undefined) concatName.value = state.concatName
  } catch (e) { /* 忽略解析异常 */ }
}

onMounted(async () => {
  await ensureWecomLogin(route.query.code)
  await loadUserInfo()
  // 恢复之前保存的筛选状态(组件可能被销毁重建)
  restoreFilterState()
  // 企微通知跳转带 state 参数时,应用 state 指定的筛选条件(一次性,用完清除 URL)
  const stateFilter = route.query.state
  if (stateFilter) {
    allFilter.value = stateFilter
    const textMap = { all: '全部', hasFollow: '有跟进人', noFollow: '无跟进人', myClue: '我的线索', beImproveContact: '待完善联系方式' }
    allFilterText.value = textMap[stateFilter] || '全部'
    saveFilterState()
    router.replace({ path: route.path, query: {} })
  }
  initData()
})

onActivated(() => {
  if (!pageContent.value) return
  if (window.consultationBookNeedRefresh) {
    initData()
    window.consultationBookNeedRefresh = false
    return
  }
  pageContent.value.scrollTop = scrollPosition
  setTimeout(() => {
    if (pageContent.value) pageContent.value.scrollTop = scrollPosition
  }, 200)
})

onUnmounted(() => {
  if (searchTimer.value) clearTimeout(searchTimer.value)
  if (scrollTimeout.value) clearTimeout(scrollTimeout.value)
})

function initData() {
  pageNum.value = 1
  hasMore.value = true
  consulationBookList.value = []
  loadConsulationBook()
  getUserListByMenuPerms({ perms: 'enrollment:consultationBook:list' }).then(response => {
    followerList.value = response
    filteredFollowerList.value = response
  })
  loadStatistics()
}

async function loadUserInfo() {
  const localUserInfo = getLocalUserInfo()
  if (localUserInfo) {
    userInfo.value = localUserInfo
    return
  }
  const userInfoResponse = await getUserInfo()
  userInfo.value = userInfoResponse
  setUserInfo(userInfoResponse)
}

function hasPermission(permission) {
  return userInfo.value?.permissions?.includes(permission) || false
}

function followRecord(consultationBookId) {
  router.push({ path: '/consultationBook/addFollowRecord', query: { consultationBookId } })
}

function handleUpdate(item) {
  router.push({ path: '/consultationBook/add', query: { consultationBookId: item.consultationBookId } })
}

function handleScroll(event) {
  scrollPosition = event.target.scrollTop
  if (scrollTimeout.value) clearTimeout(scrollTimeout.value)
  scrollTimeout.value = setTimeout(() => {
    const { scrollTop, scrollHeight, clientHeight } = event.target
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      loadConsulationBook()
    }
  }, 100)
}

function toggleAllFilter() {
  showAllFilter.value = !showAllFilter.value
  if (showAllFilter.value) showQuickFilter.value = false
}

function toggleQuickFilter() {
  showQuickFilter.value = !showQuickFilter.value
  if (showQuickFilter.value) showAllFilter.value = false
}

function selectAllFilter(type) {
  allFilter.value = type
  showAllFilter.value = false
  const textMap = { all: '全部', hasFollow: '有跟进人', noFollow: '无跟进人', myClue: '我的线索', beImproveContact: '待完善联系方式' }
  allFilterText.value = textMap[type] || '全部'
  saveFilterState()
  applyFilters()
}

function selectQuickFilter(type) {
  quickFilter.value = type
  showQuickFilter.value = false
  const textMap = { '': '全部', todayFollow: '今日待跟进', sevenDaysNoFollow: '7天未跟进', thirtyDaysNoConvert: '30天未转化', todayNew: '今日新增', thisWeekNew: '本周新增', thisMonthNew: '本月新增' }
  quickFilterText.value = textMap[type] || '快捷筛选'
  saveFilterState()
  applyFilters()
}

function applyFilters() {
  pageNum.value = 1
  hasMore.value = true
  consulationBookList.value = []
  loadConsulationBook()
}

function onSearch() {
  if (searchTimer.value) clearTimeout(searchTimer.value)
  searchTimer.value = setTimeout(() => {
    saveFilterState()
    applyFilters()
  }, 300)
}

function filterFollowers() {
  const query = followerSearchQuery.value.toLowerCase()
  filteredFollowerList.value = query
    ? followerList.value.filter(follower => follower.nickName.toLowerCase().includes(query))
    : followerList.value
}

function selectFollower(follower) {
  selectedFollower.value = follower
}

function confirmAssign() {
  if (!selectedFollower.value) return
  changeFollowUser(selectedFollower.value.userId, checkedItem.value.consultationBookId).then(response => {
    if (!response) {
      showSuccessToast('分配成功')
      applyFilters()
      showPicker.value = false
      selectedFollower.value = null
    } else {
      showFailToast(response.msg)
    }
  })
}

function cancelAssign() {
  showPicker.value = false
  selectedFollower.value = null
}

function openPicker(item) {
  checkedItem.value = item
  followerSearchQuery.value = ''
  filteredFollowerList.value = followerList.value
  showPicker.value = true
}

function claimLead(id) {
  showConfirmDialog({ title: '确认认领', message: '您确定要认领该线索吗？' }).then(() => {
    claim({ ids: [id] }).then(() => {
      showSuccessToast('认领成功')
      applyFilters()
    }).catch(() => {
      showFailToast('认领失败，请稍后重试')
    })
  }).catch(() => { })
}

function formatDate(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return year + '-' + month + '-' + day
}

function applyQuickFilterParams(params) {
  dateRange.value = []
  switch (quickFilter.value) {
    case 'todayFollow':
      params.isTodayFollow = true
      break
    case 'sevenDaysNoFollow':
      params.lastFollowDays = 7
      break
    case 'thirtyDaysNoConvert':
      params.noConvertDays = 30
      break
    case 'todayNew': {
      const today = new Date()
      dateRange.value = [formatDate(today), formatDate(new Date(today.getTime() + 24 * 60 * 60 * 1000 - 1))]
      break
    }
    case 'thisWeekNew': {
      const todayWeek = new Date()
      const weekStart = new Date(todayWeek)
      weekStart.setDate(todayWeek.getDate() - todayWeek.getDay())
      dateRange.value = [formatDate(weekStart), formatDate(new Date(weekStart.getTime() + 7 * 24 * 60 * 60 * 1000 - 1))]
      break
    }
    case 'thisMonthNew': {
      const now = new Date()
      const monthStart = new Date(now.getFullYear(), now.getMonth(), 1)
      const monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59)
      dateRange.value = [formatDate(monthStart), formatDate(monthEnd)]
      break
    }
  }
  if (dateRange.value.length === 2) {
    params.params.beginTime = dateRange.value[0]
    params.params.endTime = dateRange.value[1]
  }
}

function applyOwnerFilterParams(params) {
  if (allFilter.value === 'hasFollow') {
    params.hasFollowUser = true
    params.myClue = undefined
    params.isImproveContact = undefined
  } else if (allFilter.value === 'noFollow') {
    params.hasFollowUser = false
    params.myClue = undefined
    params.isImproveContact = undefined
  } else if (allFilter.value === 'myClue') {
    params.hasFollowUser = undefined
    params.isMyFollow = true
    params.isImproveContact = undefined
  } else if (allFilter.value === 'beImproveContact') {
    params.hasFollowUser = undefined
    params.isMyFollow = undefined
    params.isImproveContact = true
  }
}

function loadConsulationBook() {
  if (loading.value || !hasMore.value) return
  loading.value = true
  const params = { pageNum: pageNum.value, pageSize: pageSize.value, concatNameOrPhone: concatName.value, params: {} }
  applyQuickFilterParams(params)
  applyOwnerFilterParams(params)
  getConsulationBookList(params).then(response => {
    if (response) {
      consulationBookList.value = pageNum.value === 1 ? response : [...consulationBookList.value, ...response]
      if (response.length < pageSize.value) hasMore.value = false
    } else {
      hasMore.value = false
    }
    pageNum.value++
    loading.value = false
  }).catch(() => {
    loading.value = false
  })
}

function goRecord(item) {
  router.push({ path: '/consultationBookDetail', query: { consultationBookId: item.consultationBookId } })
}

function loadStatistics() {
  getStatistics().then(response => {
    if (response) statisticsData.value = response
  })
}

function addClue() {
  router.push('/consultationBook/add')
}

function makeCall(phone) {
  window.location.href = 'tel:' + phone
}

function getStatusClass(item) {
  if (item.status === 1) return 'status-blue'
  if (item.status === 2) return 'status-orange'
  if (item.status === 3) return 'status-green'
  return ''
}
</script>

<style scoped>
.consultation-book-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  box-sizing: border-box;
}

/* 移动端顶部导航栏 */
.mobile-header {
  background-color: #ff7a45;
  color: white;
  flex-shrink: 0;
  position: relative;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  font-size: 18px;
  font-weight: 600;
}

.back-btn {
  font-size: 20px;
  cursor: pointer;
}

.right-actions {
  font-size: 16px;
  cursor: pointer;
}

/* 顶部标签页 */
.tab-bar {
  display: flex;
  background-color: white;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 8px 0;
  font-size: 14px;
  color: #999;
  cursor: pointer;
  position: relative;
}

.tab-item.active {
  color: #ff7a45;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background-color: #ff7a45;
  border-radius: 2px;
}

/* 搜索框 */
.search-box {
  background-color: white;
  padding: 10px 16px;
  border-bottom: 1px solid #f0f0f0;
  position: relative;
  /* 为新增线索图标提供定位上下文 */
}

.search-input {
  width: calc(100% - 40px);
  /* 为右边的新增线索图标留出空间 */
  padding: 10px 12px;
  border: 1px solid white;
  border-radius: 20px;
  color: #333;
  font-size: 14px;
  outline: none;
  background-color: #f5f5f5;
}

.search-input::placeholder {
  color: #999;
}

/* 筛选栏 */
.filter-bar {
  display: flex;
  background-color: white;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  align-items: center;
  position: relative;
}

.filter-item {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  flex: 1;
}

.filter-item .arrow {
  margin-left: 4px;
  font-size: 10px;
  color: #999;
}

.filter-item.filter {
  color: #666;
}

.filter-item.filter .icon {
  margin-left: 4px;
  font-size: 14px;
}

/* 筛选下拉框 */
.filter-dropdown {
  background-color: white;
  border-bottom: 1px solid #f0f0f0;
  padding: 8px 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: calc(100% + 4px);
  /* 调整top值，确保显示在筛选栏下方 */
  left: 0;
  right: 0;
  width: 100%;
  z-index: 2000;
  background-color: white;
}

.dropdown-item {
  padding: 14px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #666;
  transition: background-color 0.2s;
}

.dropdown-item:hover {
  background-color: #f5f5f5;
}

.dropdown-item.active {
  color: #ff7a45;
  background-color: #fff5f0;
  font-weight: 500;
}

/* 页面内容 */
.page-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: #f5f5f5;
  padding-bottom: calc(60px + env(safe-area-inset-bottom));
}

.page-content::-webkit-scrollbar {
  width: 4px;
}

.page-content::-webkit-scrollbar-track {
  background-color: transparent;
}

.page-content::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 2px;
}

/* 线索列表项 */
.lead-item {
  background-color: white;
  padding: 16px;
  margin-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

/* 线索头部 */
.lead-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.name-section {
  display: flex;
  align-items: center;
}

.name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-right: 8px;
}

.grade-tag {
  background-color: #f0f0f0;
  color: #666;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.header-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
}

.action-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.phone-icon {
  font-size: 18px;
  margin-right: 12px;
  cursor: pointer;
  color: #666;
}

.status-tag {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.claim-btn {
  color: #1890ff;
  font-size: 14px;
  cursor: pointer;
}

.status-blue {
  color: #1890ff;
  background-color: #e6f7ff;
}

.status-orange {
  color: #fa8c16;
  background-color: #fff7e6;
}

.status-green {
  color: #52c41a;
  background-color: #f6ffed;
}

/* 线索详情 */
.lead-detail {
  font-size: 13px;
  color: #666;
}

.detail-item {
  margin-bottom: 8px;
  line-height: 1.6;
  display: grid;
  grid-template-columns: auto 1fr;
}

.detail-item:last-child {
  margin-bottom: 0;
}

.detail-item .label {
  color: #999;
  white-space: nowrap;
}

.detail-item .value {
  color: #333;
  word-break: break-word;
}

/* 无数据状态 */
.empty-state {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

/* 间距 */
.mt-10 {
  margin-top: 10px;
}

/* 加载状态 */
.loading,
.no-more {
  text-align: center;
  padding: 16px;
  color: #999;
  font-size: 14px;
}

.loading {
  color: #1890ff;
}

/* 新增线索图标样式 */
.add-clue {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: #1890ff;
  cursor: pointer;
}

.add-clue .icon {
  display: inline-block;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #1890ff;
  color: white;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
}

/* 操作按钮样式 */
.lead-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
  padding: 0 5px;
}

.page-content::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
  border-radius: 2px;
}

.action-btn {
  font-size: 15px;
  padding: 2px 12px;
  min-width: 80px;
  line-height: 1.2;
  height: 30px;
}

.selected-cell {
  color: #1989fa;
}

.van-cell {
  padding: 8px 16px;
  min-height: 40px;
}
</style>
